import { render, staticRenderFns } from "./task-personnel-pannel.vue?vue&type=template&id=7fd1fa09&scoped=true&"
import script from "./task-personnel-pannel.vue?vue&type=script&lang=js&"
export * from "./task-personnel-pannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd1fa09",
  null
  
)

export default component.exports